import _toConsumableArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * path: '/redirect/:path*'       the value is vue router path
 * serverAuthPath : '/redirect/'  the serverAuthPath is atuh menu route alias(the path alias)
 * meta : {
    isAllow: true                the field is allow async insert router auth
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/* Loadable */
// const loadable = component => () => import(component);

/* Layout */
import Layout from "@/layout";

/* Router Modules */
import { homeRouter, WMS } from "./modules";

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export var constantRoutes = [{
  path: "/redirect",
  component: Layout,
  hidden: true,
  children: [{
    path: "/redirect/:path*",
    component: function component() {
      return import("@/views/redirect/index");
    }
  }]
}, {
  path: "/login",
  component: function component() {
    return import("@/pages/login/login");
  },
  hidden: true
}, {
  path: "/applyfor",
  component: function component() {
    return import("@/pages/login/applyfor");
  },
  hidden: true
}, {
  path: "/register",
  component: function component() {
    return import("@/pages/login/register");
  },
  hidden: true
}, {
  path: "/forget",
  component: function component() {
    return import("@/pages/login/forget");
  },
  hidden: true
}, {
  path: "/dingding",
  component: function component() {
    return import("@/pages/login/dingding");
  },
  hidden: true
}, {
  path: "/auth-redirect",
  component: function component() {
    return import("@/views/login/auth-redirect");
  },
  hidden: true
}, {
  path: "/404",
  component: function component() {
    return import("@/views/error-page/404");
  },
  hidden: true
}, {
  path: "/401",
  component: function component() {
    return import("@/views/error-page/401");
  },
  hidden: true
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = [homeRouter, {
  path: "/wms",
  redirect: "/home",
  component: Layout,
  name: "WMS",
  alwaysShow: true,
  meta: {
    title: "WMS",
    icon: "user"
  },
  children: _toConsumableArray(WMS)
},
// organizationRouter,
// personnelRouter,
// systemRouter,
// 404 page must be placed at the end !!!
{
  path: "*",
  redirect: "/404",
  hidden: true,
  meta: {
    isAllow: true
  }
}];
console.log(asyncRoutes);
var createRouter = function createRouter() {
  return new Router({
    mode: "history",
    // require service support
    base: "/wms/",
    routes: constantRoutes
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;